

module.exports = __webpack_require__.stylable.create(
    "DeleteGroupRequestModal424111528",
    {"classes":{"root":"DeleteGroupRequestModal424111528__root","subtitle":"DeleteGroupRequestModal424111528__subtitle"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    1,
    "DeleteGroupRequestModal424111528",
    null
);
